import React, { useEffect, useState } from "react";
import { _findSelectOption, _getTranslation } from "../utils/helper";

import { InputSelect } from "../forms";

const YearDropdownDownloads = (props) => {
  const [jsonData, setJsonData] = useState(null);
  const [availableYears, setAvailableYears] = useState([]);
  const [year, setYear] = useState({});

  useEffect(() => {
    let reportData = props?.data?.json;
    if (reportData) {
      reportData = JSON.parse(reportData);
      setJsonData(reportData);

      const yearOptions = reportData.map((item) => ({
        value: item.url,
        label: item.label,
      }));
      setAvailableYears(yearOptions);
    }
  }, [props]);

  return (
    <React.Fragment>
      {jsonData && (
        <React.Fragment>
          <InputSelect
            name="year-select"
            placeholder={`${_getTranslation("year")}`}
            options={availableYears}
            isClearable
            isSearchable
            value={_findSelectOption(availableYears, year?.value)}
            onChange={(name, selectedValue, opt) => {
              setYear(opt);
            }}
          />

          {year && Object.keys(year).length > 0 && (
            <a
              className="btn btn-s--pill w-full mt-4"
              href={year.value}
              target="_blank"
              title={year.label}
            >
              {_getTranslation("download")}
            </a>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default YearDropdownDownloads;
